module.exports = __webpack_public_path__ + "assets/images/hhl_logo_chn_eng_name-qUcUhpl.jpg";